const Regex = {
  latLong: /^-?([1-8]?[1-9]|[1-9]0)\\.{1}\\d{1,6}/,
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  numeric: /^\d+$/,
  twoDecimal: /^(\d*)(\.\d)?\d?$/,
  text: /^[a-zA-Z ]+$/,
  number: /^\d+$/,
  onlyNumber: /[^0-9.]/g,
  alphaNumericChar: /[^a-zA-Z0-9]/g,
  replaceInvalid: /(\..*?)\..*/g,
  phoneNumber: /^[6789]\d{9}$/,
  pinCode: /^(\d{4}|\d{6})$/,
  alphaNumeric: /^[a-zA-Z0-9 ]{0,250}$/,
  // nameRegex: /^^[A-Za-z0-9 ]+[.@\-A-Za-z0-9 ]*\s[A-Za-z0-9 ]+[.@\-0-9a-zA-Z ]*$/,
  // nameRegex: /^[a-z]([-']?[a-z]+)*( [a-z]([-']?[a-z]+)*)+$/,
  nameRegex: /^[a-zA-Z][a-zA-Z\s]*$/,
  alphaNum: /^[a-zA-Z0-9 ]+$/,
  address: /^[a-zA-Z0-9 ,-/!@$&#(){}]*$/,
  toFixed: /^(?:\d*\.\d{1,2}|\d+)$/,
  panCard: /([A-Z]){5}([0-9]){4}([A-Z]){1}$/,
  panDob: /^(?:(?:31(\/)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/i,
  passwordFormat: /^(?=\S*[a-z])(?=.*[A-Z])(?=\S*[@$!%*?&])(?=\S*\d)\S{8,15}$/,
  companyname: /^[a-zA-Z0-9_]+$/,
  aadhaar: /^[0-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/,
  city: /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/,
  street: /^[ A-Za-z0-9_@./#&+-]*$/,
  last4Digit: /\d(?=\d{4})/g,
  alphanu: /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]+$/,
  aloha: /^([a-zA-Z0-9 _-]+)$/,
  flatNo: /^[a-zA-Z0-9\s,'-]*$/,
  streetNo: /^\s*\S+(?:\s+\S+){2}/,
  replaceText: /(\..*?)\..*/g,
  percentage: /(^100([.]0{1,2})?)$|(^\d{1,2}([.]\d{1,2})?)[%]{0,1}$/i,
  accountNo: /^\d{8,18}$/,
};

export default Regex;
